import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { startup } from './actions/startup'
import AppLoading from './components/AppLoading'


class Startup extends React.Component {
	componentDidMount() {
		this.props.onLoad()
	}
	render() {
		return this.props.isLoaded
			? this.props.children
			: (<AppLoading />)
	}
}
Startup.propTypes = {
	onLoad: PropTypes.func,
	isLoaded: PropTypes.bool,
	children: PropTypes.node
}

const mapStateToProps = (state) => ({
	isLoaded: state.startup.isLoaded
})

const mapDispatchToProps = (dispatch) => ({
	onLoad: () => dispatch(startup())
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Startup)


// WEBPACK FOOTER //
// ./src/Startup.js